import React, { useState } from "react";
import { toPX } from "../../../client20/logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./Slide.module.scss";

export default function Slide(props) {
  const { viewport, renderViewport, closeViewport, isEnabled, noControls } = props;
  const [isMaximized, setIsMaximized] = useState(false);
  const headerHeightInEm = "2.5em"

  const containerStyle = {
    width: isMaximized ? "100%" : toPX(viewport.width) + "px",
    height: isMaximized ? "100%" : "calc(" + toPX(viewport.height) + "px + " + headerHeightInEm + ")",
    margin: isMaximized ? 0 : "1em"
  };

  const headerStyle = {
    height: headerHeightInEm
  }

  const renderHeaderButton = (icon, onClickHandler) => {
    return (
      <Button
        stylingMode={'text'}
        icon={icon}
        onClick={onClickHandler}
        disabled={!isEnabled}
      />
    );
  };

  return (
    <div className={cn(classes.container, isMaximized ? null : 'dx-card', 'dx-theme-text-color')} style={containerStyle}>
      <div className={cn(classes.header, "dx-theme-border-color", "dx-theme-background-color")} style={headerStyle} >
        <div />
        <div className={"ui-font-bold-1"}>{viewport.displayName}</div>
        <div>
          {!noControls
            ? (
              <React.Fragment>
                {renderHeaderButton(isMaximized ? 'unselectall' : 'fullscreen', () => setIsMaximized(!isMaximized))}
                {renderHeaderButton('close', () => closeViewport(viewport.viewportId))}
              </React.Fragment>
            )
            : null
          }
        </div>
      </div>

      {/* <div style={containerStyle}> */}
      {renderViewport(viewport, isEnabled)}
      {/* </div> */}
    </div>
  );
}
